import script from "./AddUserEmployee.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddUserEmployee.vue?vue&type=script&setup=true&lang=ts"

import "./AddUserEmployee.vue?vue&type=style&index=0&id=ce6511b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce6511b8"]])

export default __exports__